import { Injectable } from "@angular/core";
import { Store } from "../../../@core/store/store";
import { Subject } from "rxjs";
import { environment } from "../../../../environments/environment";
import {
  ApplicationSearchLoadedState,
  ApplicationSearchLoadingErrorState,
  ApplicationSearchLoadingState,
  BingSearchLoadedState,
  BingSearchLoadingErrorState,
  BingSearchLoadingState,
  profileDataLoadedState,
  profileDataLoadingErrorState,
  profileDataLoadingState,
} from "./home.state";

@Injectable({
  providedIn: "root",
})
export class HomeService extends Store.AbstractService {
  bingSearch(searchQuery) {
    const me = this;

    const output = new Subject<Store.State>();
    setTimeout(() => {
      output.next(new BingSearchLoadingState());
    }, 0);

    const path = me.controller.replaceVariables(
      environment.api.bingsearch.endpoint,
      { searchQuery }
    );

    me.controller.get(path, null, undefined, { Authorization: true }).subscribe(
      (data: any) => {
        output.next(new BingSearchLoadedState(data));
        output.complete();
      },
      (e: any) => {
        output.error(new BingSearchLoadingErrorState(e));
        output.complete();
      }
    );
    return output;
  }

  applicationSearch(searchQuery: string) {
    const me = this;

    const output = new Subject<Store.State>();
    setTimeout(() => {
      output.next(new ApplicationSearchLoadingState());
    }, 0);

    const path = me.controller.replaceVariables(
      environment.api.applicationSearch.endpoint,
      { searchQuery }
    );

    me.controller.get(path, null, undefined, { Authorization: true }).subscribe(
      (data: any) => {
        output.next(new ApplicationSearchLoadedState(data));
        output.complete();
      },
      (e: any) => {
        output.error(new ApplicationSearchLoadingErrorState(e));
        output.complete();
      }
    );
    return output;
  }

  private cacheKey = 'profile';
  private cacheExpiration = 10 * 60 * 1000; // 10 minutes

  private cacheData(data: any): void {
    localStorage.setItem(this.cacheKey, JSON.stringify({ data, cacheTime: new Date().getTime() }));
  }

  clearAttendanceCache(){
    localStorage.removeItem(this.cacheKey)
  }



  fetchProfileData(empId) {
    const me = this;
    const output = new Subject<Store.State>();

    setTimeout(() => {
      output.next(new profileDataLoadingState());
    }, 0);

    const cachedData = JSON.parse(localStorage.getItem(this.cacheKey));
    const now = new Date().getTime();



    if (cachedData && (now - cachedData.cacheTime < this.cacheExpiration)) {
      setTimeout(() => {
        // Emit cached data first, but do NOT complete the Subject here
        output.next(new profileDataLoadedState(cachedData.data));
      }, 0);
    }

    const path = me.controller.replaceVariables(
      environment.api.profile.userProfile.endpoint,
      { empId }
    );

    me.controller.get(path, null, undefined, { Authorization: true }).subscribe(
      (data: any) => {
        this.cacheData(data)
        output.next(new profileDataLoadedState(data));
        output.complete();
      },
      (e: any) => {
        output.error(new profileDataLoadingErrorState(e));
        output.complete();
      }
    );
    return output;
  }

}
